import { useQuery } from '@tanstack/react-query';
import axios from '../../axiosConfig';
import { GET_ORDER_FORMAT_NUMBER } from '../queries/GetOrderDetails';

const fetchFormatNumber = async ({ queryKey }) => {
    const [, { token, item, setToast }] = queryKey;

    if (!token) throw new Error('token not available');
    
    try {
        const endpointUrl = `/getFormatNumber?&esoiNumber=${encodeURIComponent(item?.esoi)}&PCL=${encodeURIComponent(item?.pcl)}`;

        const response = await axios.get(endpointUrl, {
            headers: {
                Authorization: token,
            }
        });

        return response.data;

    } catch (error) {
        setToast({ showToast: true, message: error.response?.data, type: 'error' });
    }
};

export const useGetFormatNumber = (params) => {
    return useQuery({
        queryKey: [GET_ORDER_FORMAT_NUMBER, params],
        queryFn: fetchFormatNumber,
        enabled: !!params.token,
        retry: false,
    });
};

